var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrafficPages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66732 9.16406H4.66732M6.33398 12.4974H4.66732M11.334 5.83073H4.66732M14.6673 8.33073V5.66406C14.6673 4.26393 14.6673 3.56387 14.3948 3.02909C14.1552 2.55868 13.7727 2.17623 13.3023 1.93655C12.7675 1.66406 12.0674 1.66406 10.6673 1.66406H5.33398C3.93385 1.66406 3.23379 1.66406 2.69901 1.93655C2.2286 2.17623 1.84615 2.55868 1.60647 3.02909C1.33398 3.56387 1.33398 4.26393 1.33398 5.66406V14.3307C1.33398 15.7309 1.33398 16.4309 1.60647 16.9657C1.84615 17.4361 2.2286 17.8186 2.69901 18.0582C3.23379 18.3307 3.93385 18.3307 5.33398 18.3307H8.41732M13.0007 17.4974C13.0007 17.4974 15.5007 16.3058 15.5007 14.5184V12.4331L13.6777 11.7817C13.2397 11.6248 12.7607 11.6248 12.3227 11.7817L10.5007 12.4331V14.5184C10.5007 16.3058 13.0007 17.4974 13.0007 17.4974Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficPages);
export default __webpack_public_path__ + "static/media/traffic-pages.db484e1e6676b3d2357814c6f9f9fb4e.svg";
export { ForwardRef as ReactComponent };